import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const CalendarIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M4.51169 3.76364V0.771429M13.4883 3.76364V0.771429M5.25974 12.7403H12.7403M0.771429 8.25195V16.5429C0.771429 16.9216 1.07843 17.2286 1.45714 17.2286H16.5429C16.9216 17.2286 17.2286 16.9216 17.2286 16.5429V8.25195M0.771429 8.25195V4.44935C0.771429 4.07064 1.07843 3.76364 1.45714 3.76364H16.5429C16.9216 3.76364 17.2286 4.07064 17.2286 4.44935V8.25195M0.771429 8.25195H17.2286"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

CalendarIcon.displayName = 'CalendarIcon';
